import { Button } from '@/lib';
import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { FC, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type CongratulationScreenProps = {
  title: TranslationKeys;
  titleValues?: Record<string, string | number>;
  subtitle: TranslationKeys;
  primaryButton?: {
    text: TranslationKeys;
    icon?: ReactNode;
    onClick: VoidFunction;
  };
  secondaryButton?: {
    text: TranslationKeys;
    icon?: ReactNode;
    onClick: VoidFunction;
  };
  showHeader?: boolean;
};

export const CongratulationScreen: FC<CongratulationScreenProps> = ({ title, titleValues, subtitle, primaryButton, secondaryButton, showHeader = false }) => {
  const { t } = useTranslation();
  const translateKey = (key: TranslationKeys) => toRuntimeTranslationKey(key);
  const translate = (key: TranslationKeys) => t(translateKey(key) as any);

  return (
    <div className='flex flex-col gap-12'>
      {showHeader && <h1 className='text-center text-6xl font-semibold text-brand-600'>{t('ALL:congratulation')}</h1>}
      <div>
        <img className='mx-auto my-0' src='/assets/image/bg-congratulation-screen.svg' />
        <div className='flex flex-col gap-5 p-6'>
          <div>
            <h2 className='text-center font-semibold text-primary-900'>
              <Trans
                i18nKey={translateKey(title) as any}
                values={titleValues}
                components={{
                  highlight: <span className='text-brand-600' />,
                }}
              />
            </h2>
            <p className='text-center text-sm text-tertiary-600'>{translate(subtitle)}</p>
          </div>
          <div className='flex items-center justify-center gap-3'>
            {secondaryButton && (
              <Button intent='secondary' onClick={secondaryButton.onClick}>
                {secondaryButton.icon} {translate(secondaryButton.text)}
              </Button>
            )}

            {primaryButton && (
              <Button intent='primary' onClick={primaryButton.onClick}>
                {primaryButton.icon} {translate(primaryButton.text)}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
